import { faArrowLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormEvent, useEffect, useState } from 'react';
import { Button, Card, Container, Form, Modal } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';

const TestComponent = () => {
  const { getTest, courses, validateTest } = useFirebase();
  const { courseId, id } = useParams<any>();
  const history = useHistory();
  const [test, setTest] = useState<any>(null);
  const [answers, setAnswers] = useState<{ [key: string]: any }>({});
  const [isValidating, setIsValidating] = useState(false);
  const [showValidationDialog, setShowValidationDialog] = useState(false);
  const [testSuccess, setTestSuccess] = useState<boolean>(null);
  const { isNative } = useCapacitor();
  const { t } = useTranslation();

  useEffect(() => {
    if (!courseId || !id) history.goBack();
  }, []);

  useEffect(() => {
    (async () => {
      if (!id) return;
      const test = await getTest(courseId, id);
      if (!test) return;
      setTest(test);
    })();
  }, [id, courses]);

  const onTestSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const obj = { [courseId]: { [id]: answers } };
    setIsValidating(true);
    const { status } = await validateTest(obj);
    setIsValidating(false);
    setTestSuccess(status);
    setShowValidationDialog(true);
  };

  if (!test) return <FullscreenLoader />;

  return (
    <AppShell>
      <div className={'d-flex flex-column flex-grow-1'}>
        <Title>{test.name}</Title>

        <Container className={'my-5'}>
          <div className={'d-flex align-items-center mb-3'}>
            <Button className={'tootor-button tootor-button--basic mr-2'} onClick={() => history.push('..')}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
            <h1 className="text-page-title mb-0">{test.name}</h1>
          </div>

          <Form onSubmit={onTestSubmit}>
            {test.questions.map((question) => (
              <Card key={question.id} className={'surface-card mb-3'}>
                <Card.Body>
                  <Card.Title>{question.value}</Card.Title>
                  {question.answers.map((answer) => (
                    <Form.Check
                      required
                      disabled={isValidating}
                      key={answer.id}
                      name={question.id}
                      type={'radio'}
                      label={answer.value}
                      id={answer.id}
                      value={answer.id}
                      onChange={(e) => {
                        const { value } = e.target;
                        setAnswers((previous) => ({ ...previous, [question.id]: value }));
                      }}
                    />
                  ))}
                </Card.Body>
              </Card>
            ))}

            <div className={'d-flex justify-content-end'}>
              <Button className={'tootor-button tootor-button--secondary'} type={'submit'} style={{ width: '150px' }} disabled={isValidating}>
                {isValidating ? <FontAwesomeIcon icon={faCircleNotch} spin /> : t('labels.invia')}
              </Button>
            </div>
          </Form>
        </Container>

        <Footer />
      </div>

      <Modal className="tootor-modal" centered={isNative} show={showValidationDialog} onHide={() => history.push('..')}>
        <Modal.Header>
          <Modal.Title>{testSuccess ? t('test.labels.testSuperato') : t('test.labels.testNonSuperato')}</Modal.Title>
        </Modal.Header>
        {/*<Modal.Body>
          Hai terminato i minuti a disposizione per la versione di prova. Per continuare ad usufruire dei contenuti di {process.env.REACT_APP_TITLE} è
          necessario un abbonamento.
        </Modal.Body>*/}
        <Modal.Footer>
          <Button className="tootor-button tootor-button--secondary" onClick={() => history.push('..')}>
            {t('test.labels.tornaAlCorso')}
          </Button>
        </Modal.Footer>
      </Modal>
    </AppShell>
  );
};

export default TestComponent;
